import { ThemeProvider as NextThemesProvider } from "next-themes"
import { type ThemeProviderProps } from "next-themes/dist/types"

/**
 * ThemeProvider wrapper for next-themes
 * Prevents FOUC via inline script in index.html
 * Uses localStorage to persist theme preference
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider 
      attribute="class" 
      defaultTheme="system"
      enableSystem={true}
      storageKey="voy-theme"
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}